import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Transportation_and_lifting_of_glass_in_a_vacuum() {
  return (
    <div className="Transportation_of_building_materials-page">

      <div className="Transportation_of_building_materials-hero">
        <div className="Transportation_of_building_materials-overlay">
          <h1>הובלה והרמה של זכוכית בוואקום</h1>
        </div>
      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלה והרמה של זכוכית בוואקום
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/6.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלה והרמת הזכוכית בוואקום של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלה והרמה של זכוכית בוואקום דורשות תכנון נכון, ציוד
            מתאים וניסיון בעבודה עם לוחות זכוכית בגדלים ובמשקלים
            שונים. נצר הובלות ומנופים מספקת שירותי הובלה והרמה
            של זכוכית לקבלנים, חברות, מתקינים, עסקים ולקוחות פרטיים,
            בהתאם לסוג הזכוכית, למידות, למשקל ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/42.jpeg"
                alt="הובלה והרמה של זכוכית בוואקום"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת לוחות זכוכית דורשת התאמה בין סוג הזכוכית,
                המידות, המשקל ותנאי הגישה במקום האיסוף וההתקנה.
                לפני ביצוע העבודה חשוב לבחון את גודל הלוחות,
                משקלם, נקודת האיסוף, נקודת ההצבה ואפשרויות הגישה.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות להובלה ולהרמה
                של מגוון סוגי זכוכית, לרבות זכוכית לחלונות,
                חזיתות זכוכית, ויטרינות, זכוכית למבנים ולוחות
                זכוכית גדולים, בהתאם לסוג העבודה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלה והרמה של זכוכית בוואקום – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודת הובלה והרמה של זכוכית מתחילה בבדיקת פרטי
              העבודה. יש להבין מהו סוג הזכוכית, מהן המידות, מהו
              המשקל הכולל ומהי נקודת האיסוף וההתקנה.
            </p>

            <p>
              בנוסף יש לבחון את תנאי הדרך ואת הגישה לאתר, לרבות
              רחובות צרים, חניות, שערים, אתרי בנייה, בניינים,
              מרפסות, פתחים ומגבלות אחרות שעלולות להשפיע על
              ביצוע העבודה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת זכוכית באמצעות משאית
            </h2>

            <p>
              משאית מתאימה מאפשרת להעביר לוחות זכוכית מהמפעל,
              המחסן או נקודת האיסוף אל אתר היעד בצורה מסודרת.
              התאמת אמצעי ההובלה נעשית בהתאם למידות הזכוכית,
              למשקל ולתנאי הגישה.
            </p>

            <p>
              במקרים שבהם יש צורך גם בהרמה ופריקה באמצעות מנוף
              או ציוד הרמה מתאים, ניתן לשלב פתרון הכולל הובלה
              והרמה בהתאם לדרישות העבודה ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הרמת זכוכית באתרי בנייה
            </h2>

            <p>
              באתרי בנייה ובפרויקטים של שיפוץ או התקנה יש לעיתים
              צורך להרים לוחות זכוכית מקומת הקרקע אל קומות גבוהות
              או להעביר אותם אל אזור התקנה שאינו נגיש ישירות.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלה והרמת זכוכית
              לאתרי בנייה, עסקים, מבנים פרטיים ולמגוון נקודות
              ברחבי הארץ, בהתאם לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הרמת זכוכית בוואקום
            </h2>

            <p>
              שימוש במערכת הרמה בוואקום מאפשר לאחוז בלוחות זכוכית
              ולהעביר אותם בצורה מבוקרת אל נקודת ההתקנה, בהתאם
              לסוג הציוד ולתנאי העבודה.
            </p>

            <p>
              הרמה בוואקום יכולה להתאים במקרים שבהם נדרשת העברה
              של לוחות זכוכית גדולים אל חזיתות מבנים, חלונות,
              פתחים, מרפסות ואזורים נוספים שבהם הגישה מורכבת.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלה והרמה של לוחות זכוכית גדולים
            </h2>

            <p>
              לוחות זכוכית מגיעים במגוון גדלים, עוביים ומשקלים.
              לפני ביצוע העבודה יש לבדוק את מידות הלוחות, משקלם,
              אופן השינוע והאפשרות לבצע את ההרמה וההצבה במקום.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההובלה וההרמה כך
              שיתאימו למידות הזכוכית, למשקל, לנקודת ההתקנה ולתנאי
              הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלה והרמה של זכוכית?
            </h2>

            <p>
              עבודה עם זכוכית דורשת תכנון מוקדם, התאמת ציוד מתאים
              ובדיקה של תנאי השטח. תכנון נכון יכול לסייע בביצוע
              ההובלה וההרמה בצורה מסודרת ובהתאם לתנאי העבודה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה וההרמה
              לסוג הזכוכית, למידותיה, למשקל, לתנאי הדרך ולדרישות
              הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלה והרמה של זכוכית בוואקום בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלה והרמה
              של זכוכית בוואקום לקבלנים, מתקיני זכוכית, חברות,
              עסקים ולקוחות פרטיים. השירות ניתן בהתאם לסוג
              הזכוכית, למידות, למשקל ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים הובלה או הרמה של זכוכית בוואקום? צרו איתנו
              קשר, ספרו לנו מה גודל הזכוכית, מה המשקל והיכן נדרשת
              ההרמה או ההובלה, ונבחן עבורכם את פתרון העבודה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Container_Transportation"
              className="link-right"
            >
הובלת מכולות            </Link>

            <Link
              to="/Transportation_of_industrial_and_heavy_generators"
              className="link-left"
            >
הובלת גנרטורים תעשייתיים כבדים
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
